import { ContractSummaryDto } from "api/contract";
import { GenericColors } from "enums/genericColors";
import { ContractTableRowKey } from "../types/enums";
import { ContractRow, ContractType } from "../types/interfaces";
import { toDayInput } from 'core/utils/dates';

export function mapContractSummary(contractSummary: ContractSummaryDto): ContractRow {
  return {
    id: contractSummary.id,
    riskId: contractSummary.riskId || '',
    [ContractTableRowKey.DATE]: contractSummary.date.toISOString(),
    [ContractTableRowKey.STATUS]: {
      color: contractSummary.statusColor as GenericColors,
      label: contractSummary.statusLabel
    },
    [ContractTableRowKey.PRODUCT]: contractSummary.product || '_',
    [ContractTableRowKey.OWNER]: contractSummary.owner,
    [ContractTableRowKey.INSUREDS]: contractSummary.insureds ? contractSummary.insureds.map(item => item.label).join(', ') : '', // Concatène les labels
    [ContractTableRowKey.CLIENT_PRICE]: `${contractSummary.clientPrice?.toFixed(2).toString()} €` || '_',
    [ContractTableRowKey.CONTRACT_IDENTIFIER]: {
      id: contractSummary.contractIdentifier.id,
      label: contractSummary.contractIdentifier.label,
      type: contractSummary.support as ContractType,
    },
    [ContractTableRowKey.SUPPORT]: contractSummary.support || '_',
    [ContractTableRowKey.UNREAD_NOTIFICATION_COUNT]: contractSummary.unreadNotificationCount || 0,
    // Métadonnées optionnelles (absentes si null côté back)
    productLabel: contractSummary.productLabel ?? undefined,
    tunnelLabel: contractSummary.tunnelLabel ?? undefined,
    // Dates calendaires : jour "yyyy-MM-dd" sans conversion de fuseau (jamais toISOString)
    effectiveDate: contractSummary.effectiveDate ? toDayInput(contractSummary.effectiveDate) : undefined,
    endDate: contractSummary.endDate ? toDayInput(contractSummary.endDate) : undefined,
    mainDueDate: contractSummary.mainDueDate ?? undefined,
  };
}

export function mapContractSummaries(quoteSummaries: ContractSummaryDto[]): ContractRow[] {
  return quoteSummaries.map(mapContractSummary);
}
